import { Resume } from "lib/redux/types";
import { ResumeAnalysis } from "lib/resume-scoring/resume-analysis/resume-analyse-types";

const RESUME_ANALYSIS_CACHE_KEY = "resumeAnalysisCache";
const RESUME_CACHE_KEY = "resumeCache";
const EXPERIENCE_CACHE_KEY = "experienceCache";
const RESUME_SCORE_CACHE_KEY = "resumeScoreCache";

export const getResumeScoreCache = (): any | null => {
  if (typeof window === "undefined") return null;

  try {
    const cachedData = localStorage.getItem(RESUME_SCORE_CACHE_KEY);

    if (cachedData) {
      return JSON.parse(cachedData) as any;
    }
  } catch (e) {
    console.error("Failed to get cached resume score", e);
  }
  return null;
}

export const setResumeScoreCache = ({score}: {score: any}) => {
  if (typeof window === "undefined") return;

  try {
    localStorage.setItem(RESUME_SCORE_CACHE_KEY, JSON.stringify(score));
  } catch (e) {
    console.error("Failed to set resume score cache", e);
  }
}

export const clearResumeScoreCache = () => {
  if (typeof window === "undefined") return;

  try {
    localStorage.removeItem(RESUME_SCORE_CACHE_KEY);
  } catch (e) {
    console.error("Failed to clear resume score cache", e);
  }
} 

export const setExperienceCache = ({experience}: {experience: string}) => {
  if (typeof window === "undefined") return;

  try {
    localStorage.setItem(EXPERIENCE_CACHE_KEY, experience);
  } catch (e) {
    console.error("Failed to set experience cache", e);
  }
}

export const getExperienceCache = (): "EXPERIENCED" | "FRESHER" | null => {
  if (typeof window === "undefined") return null;

  try {
    const cachedData = localStorage.getItem(EXPERIENCE_CACHE_KEY);

    if (cachedData) {
      return cachedData as "EXPERIENCED" | "FRESHER";
    }
  } catch (e) {
    console.error("Failed to get experience cache", e);
  }
  return null;
}

export const clearExperienceCache = () => {
  if (typeof window === "undefined") return;

  try {
    localStorage.removeItem(EXPERIENCE_CACHE_KEY);
  } catch (e) {
    console.error("Failed to clear experience cache", e);
  }
}

export const getResumeAnalysisCache = (): ResumeAnalysis | null => {
  if (typeof window === "undefined") return null;

  try {
    const cachedData = localStorage.getItem(RESUME_ANALYSIS_CACHE_KEY);

    if (cachedData) {
      return JSON.parse(cachedData) as ResumeAnalysis;
    }
  } catch (e) {
    console.error("Failed to get cached resume analysis", e);
  }
  return null;
}

export const setResumeAnalysisCache = ({resumeAnalysis}: {resumeAnalysis: ResumeAnalysis}) => {
  if (typeof window === "undefined") return;
  
  try {
    localStorage.setItem(RESUME_ANALYSIS_CACHE_KEY, JSON.stringify(resumeAnalysis));
  } catch (e) {
    console.error("Failed to set resume analysis cache", e);
  }
};

export const clearResumeAnalysisCache = () => {
  if (typeof window === "undefined") return;

  try {
    localStorage.removeItem(RESUME_ANALYSIS_CACHE_KEY);
  } catch (e) {
    console.error("Failed to clear resume analysis cache", e);
  }
}

export const setResumeCache = ({resume}: {resume: Resume}) => {
  if (typeof window === "undefined") return;

  try {
    localStorage.setItem(RESUME_CACHE_KEY, JSON.stringify(resume));
  } catch (e) {
    console.error("Failed to set resume cache", e);
  }
};

export const getResumeCache = (): Resume | null => {
  if (typeof window === "undefined") return null;

  try {
    const cachedData = localStorage.getItem(RESUME_CACHE_KEY);

    if (cachedData) {
      return JSON.parse(cachedData) as Resume;
    }
  } catch (e) {
    console.error("Failed to get cached resume", e);
  }
  return null;
}

export const clearResumeCache = () => {
  if (typeof window === "undefined") return;

  try {
    localStorage.removeItem(RESUME_CACHE_KEY);
  } catch (e) {
    console.error("Failed to clear resume cache", e);
  }
}